import {Action, lazyGet} from "@dp-instant/core";
import {inject, injectable} from "inversify";
import {TypesGame} from "@game/TypesGame";
import {GameModel} from "@game/coregame/model/GameModel";
import {ISocial} from "@dp-instant/social";
import {TypesFlow, TypesSocial} from "@dp-instant/interfaces";
import {LevelNextActionSIO} from "@game/actions/LevelNextActionSIO";

@injectable()
export class StartGameAction extends Action {
    @inject(TypesGame.model)
    private readonly model: GameModel;

    @inject(TypesSocial.model)
    private readonly social: ISocial;

    @inject(TypesFlow.LevelNext)
    private readonly levelNext: LevelNextActionSIO;

    async execute(): Promise<void> {
        await this.social.showBotPopup();
        await this.levelNext.run();
        lazyGet(TypesGame.actions.bannerControllerGameDistribution);
    }
}
